import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useStyle } from "hooks/useStyle";
import buttonBg from "utils/img/telegram-button-bg.png";
import { ReactComponent as TelegramIcon } from "utils/img/telegram-icon.svg";
import { RESPONSIVE_SIZES } from "utils/tools";

export const TelegramButton = ({
  loginPage = false,
  isMenuCollapsed,
}: {
  loginPage?: boolean;
  isMenuCollapsed?: boolean;
}) => {
  const { t } = useTranslation();
  const style = useStyle();

  return style.sales_telegram && !style.is_fc ? (
    <StyledButton target="_blank" href={style.sales_telegram || ""}>
      <StyledIcon $loginPage={loginPage} />
      {!isMenuCollapsed && (
        <StyledTextInfo loginPage={loginPage}>
          {loginPage ? "Join us on Telegram" : t("Читай нас в Telegram")}
        </StyledTextInfo>
      )}
    </StyledButton>
  ) : (
    <></>
  );
};

const StyledButton = styled.a`
  width: 100%;
  padding: 13px 10px;
  background: url(${buttonBg}) center center/cover no-repeat;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  text-decoration: none;
`;

const StyledIcon = styled(TelegramIcon)<{ $loginPage?: boolean }>`
  width: ${(props) => (props.$loginPage ? "38px" : "24px")};
  height: ${(props) => (props.$loginPage ? "38px" : "24px")};

  @media (${RESPONSIVE_SIZES.lg}) {
    width: 24px;
    height: 24px;
  }
`;

const StyledTextInfo = styled.div<{ loginPage?: boolean }>`
  margin-left: 12px;
  color: #fff;
  font-size: ${(props) => (props.loginPage ? "20px" : "16px")};
  line-height: 130%;

  @media (${RESPONSIVE_SIZES.lg}) {
    font-size: 16px;
  }
`;
